<mat-card class="assign-ticket-dialog pt-6">
  <p class="font-semibold !text-xl !mb-8 text-center text-primary-main">
    {{ "ticketManagement.details.assign" | translate }}
  </p>
  @if (form) {
    <form [formGroup]="form">
      <app-select
        labelKey="assignedTo"
        formControlName="employee"
        [formGroup]="form"
        [options]="employeesSelectOptions"
        [loading]="isLoading"
      ></app-select>
      <div class="flex w-full justify-end gap-2 mt-4">
        <button
          mat-flat-button
          color="primary"
          class="w-full !text-white"
          (click)="submit()"
        >
          {{ "submit" | translate }}
        </button>
        <button
          (click)="cancel()"
          mat-stroked-button
          color="primary"
          class="w-full"
        >
          {{ "close" | translate }}
        </button>
      </div>
    </form>
  }
</mat-card>
